
import { Layout } from "@/components/Layout";
import { CreatePostDialog } from "@/components/CreatePostDialog";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CreatePost = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  // This effect ensures we navigate back if the dialog is already closed when component mounts
  useEffect(() => {
    if (!isOpen) {
      navigate('/');
    }
  }, [isOpen, navigate]);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) {
      // Navigate back when dialog is closed
      navigate('/');
    }
  };

  return (
    <Layout>
      <div className="flex justify-center items-center h-full">
        <CreatePostDialog 
          openByDefault={true} 
          open={isOpen} 
          onOpenChange={handleOpenChange} 
        />
      </div>
    </Layout>
  );
};

export default CreatePost;
